import { gql } from '@apollo/client';

export const savePolicyCancellation = gql`mutation savePolicyCancellation($soId: String!, $cancellationDate: String, $file: String, $fileName: String, $mimeType: String) {
  savePolicyCancellation(id: $soId, cancellationDate: $cancellationDate, file: $file, fileName: $fileName, mimeType: $mimeType)
}`;
